import CardLikeAmount from "./card-like-amount";

export default CardLikeAmount;